import { useEffect, useRef, useState } from "react";
import About from "./component/About/About";
import Contact from "./component/Contact/Contact";
import CustomCursor from "./component/CustomCursor/CustomCursor";
import Skills from "./component/Skills/Skills";
import Header from "./component/Header/Header";
import Project from "./component/Project/Project";
import Navbar from "./component/Navbar/Navbar";
import Preloader from "./component/Loader/Preloader";
import { LocomotiveScrollProvider as LSP } from "react-locomotive-scroll";
import "locomotive-scroll/dist/locomotive-scroll.css";
// import "locomotive-scroll/src/locomotive-scroll.scss";
import "./style/App.scss";
import { AnimatePresence, AnimateSharedLayout } from "framer-motion";
import Footer from "./component/Footer/Footer";

const App = () => {
  // states
  const [preloader, setPreloader] = useState(true);
  const [timer, setTimer] = useState(3);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0,
  });
  const [cursorVariant, setCursorVariant] = useState("default");

  // refs
  const id = useRef(null);
  const containerRef = useRef(null);

  // functions
  const clear = () => {
    window.clearInterval(id.current);
    setPreloader(false);
  };

  useEffect(() => {
    id.current = window.setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 0);
  }, []);

  useEffect(() => {
    if (timer <= 0) {
      clear();
    }
  }, [timer]);

  useEffect(() => {
    const mouseFunc = (e) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY,
      });
    };
    window.addEventListener("mousemove", mouseFunc);
    return () => {
      window.removeEventListener("mousemove", mouseFunc);
    };
  }, []);
  // framer motion variants
  const variants = {
    default: {
      x: mousePosition.x - 25,
      y: mousePosition.y - 25,
      height: 50,
      width: 50,
      backgroundColor: "#fff",
      mixBlendMode: "difference",
    },
    text: {
      x: mousePosition.x - 75,
      y: mousePosition.y - 75,
      height: 150,
      width: 150,
      backgroundColor: "#fff",
      mixBlendMode: "exclusion",
    },
    sword: {
      x: mousePosition.x - 75,
      y: mousePosition.y - 75,
      height: 150,
      width: 150,
      background: "none",
      backgroundImage: `url("/assets/m.png")`,
      backgroundSize: "contain",
      transformOrigin: "center",
      backgroundRepeat: "no-repeat",
      // mixBlendMode: "color",
    },
    diff: {
      x: mousePosition.x - 100,
      y: mousePosition.y - 100,
      background: "none",
    },
    differ: {
      x: mousePosition.x - 100,
      y: mousePosition.y - 100,
      background: "none",
    },
  };

  return (
    <>
      <CustomCursor cursorVariant={cursorVariant} variants={variants} />

      <LSP
        options={{
          smooth: true,
          tablet: { smooth: true },
          smartphone: { smooth: true },
        }}
        watch={[`animateScroll`]}
        containerRef={containerRef}
      >
        <div
          className="main-container"
          id="main-container"
          data-scroll-container
          ref={containerRef}
        >
          <Navbar setCursorVariant={setCursorVariant} />
          <Header setCursorVariant={setCursorVariant} />
          <About setCursorVariant={setCursorVariant} />
          <Skills setCursorVariant={setCursorVariant} />
          <Project setCursorVariant={setCursorVariant} />
          <Contact setCursorVariant={setCursorVariant} />
        </div>
      </LSP>
    </>
  );
};

export default App;
